import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectTypeActions from './project-type.actions';
import { ProjectTypeService } from '../../services/project-type.service';

@Injectable()
export class ProjectTypeEffects {
  loadProjectType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectTypeActions.loadProjectType),
      exhaustMap((_) =>
        this.projectTypeService.getProjectType().pipe(
          map((data) =>
            ProjectTypeActions.loadProjectTypeSuccess({ projectType: data })
          ),
          catchError((error) =>
            of(ProjectTypeActions.loadProjectTypeFailure({ error }))
          )
        )
      )
    )
  );

  addProjectType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectTypeActions.addProjectType),
      concatMap(({ newProjectType }) =>
        this.projectTypeService.createProjectType(newProjectType).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return ProjectTypeActions.addProjectTypeSuccess({
              newProjectType: data,
            });
          }),
          catchError((error) =>
            of(
              ProjectTypeActions.addProjectTypeFailure({
                error: error.error.message,
              })
            )
          )
        )
      )
    )
  );

  updateProjectType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectTypeActions.updateProjectType),
      map((action) => action.updateProjectType),
      concatMap((updateProjectType) =>
        this.projectTypeService.updateProjectType(updateProjectType).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return ProjectTypeActions.updateProjectTypeSuccess({
              updateProjectType: updateProjectType,
            });
          }),
          catchError((error) =>
            of(
              ProjectTypeActions.updateProjectTypeFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  removeProjectType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectTypeActions.removeProjectType),
      map((action) => action.ids),
      concatMap((ids) =>
        this.projectTypeService.deleteProjectType(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProjectTypeActions.removeProjectTypeSuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProjectTypeActions.updateProjectTypeFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectTypeService: ProjectTypeService,
    private notification: NotificationService
  ) {}
}
